import React, { forwardRef } from 'react';
import styles from './Skeleton.module.css';

/**
 * Skeleton — a shadcn-style loading placeholder in Athena's idiom (TSX +
 * CSS Module + 2.0 tokens). A single div: --muted fill, --ds2-radius-md
 * corners, 2s opacity pulse.
 *
 * Size and shape come from the caller (className or style), matching the
 * shadcn API: <Skeleton style={{ height: 16, width: 250 }} />.
 *
 * Distinct from DataTable's private shimmer skeleton rows, which keep their
 * gradient-sweep look.
 */

const Skeleton = forwardRef<HTMLDivElement, React.ComponentProps<'div'>>(
  ({ className = '', ...props }, ref) => (
    <div
      ref={ref}
      data-slot="skeleton"
      className={`${styles.skeleton} ${className}`.trim()}
      {...props}
    />
  ),
);

Skeleton.displayName = 'Skeleton';

export default Skeleton;
export { Skeleton };
